module.exports = __webpack_public_path__ + "mr.f12d5fde5917416ce650.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mr.svg
// module chunks = styles